import { useQuery } from '@tanstack/react-query';
import { screenAnalyticsApi } from '@/api/screenAnalytics.api';

export function useScreenViews(days: 7 | 30 | 90) {
  return useQuery({
    queryKey: ['screen-analytics', 'views', days],
    queryFn: () => screenAnalyticsApi.getScreenViews(days),
    staleTime: 60_000,
  });
}

export function useFunnel(days: 7 | 30 | 90) {
  return useQuery({
    queryKey: ['screen-analytics', 'funnel', days],
    queryFn: () => screenAnalyticsApi.getFunnel(days),
    staleTime: 60_000,
  });
}
